export const achievementData = {
    bio : "Few of the achievements of Dr. Datta are mentioned here:",
    achievements : [
        {
            id : 1,
            title : 'GOLD MEDAL for research',
            details : 'Dr Datta was awarded a GOLD MEDAL for research by G.O.I in 1975.',
            date : '1975',
            field : 'Research',
            image : 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQzt1RY6p_npmGry26SGd96yUHm6GmWxuEQ8w&s'
        },
        {
            id : 2,
            title : 'International Man of the Year',
            details : 'The International Biographical Centre, Cambridge, UK, nominated Dr Datta as the International man for the 1992-93.',
            date : '1992-93',
            field : 'Research',
            image : 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSV7S2EGTQWC9woZX4iYKPEzlKDhzY7hFyfsg&s'
        },
        {
            id : 3,
            title : 'Outstanding Research',
            details : 'On the 20th Anniversary of NCMRWF, Dr. Datta was felicitated by Ministry of Earth Sciences, Govt. of India, for his Outstanding Research.',
            date : '9th December 2008',
            field : 'Research',
            image : 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRGmKQYSZAiZFEZVwbEPGtyJKCmoY-FxYrAHg&s'
        },
        {
            id : 4,
            title : 'Felicitated by Lingaya\'s University',
            details : 'Felicitated for his “Exceptional Contributions and leadership in promoting Computer Technology and Education in India” by Lingaya\'s University during the International Conference on Reliability Infocom Technology and Optimization (ICRITO 2010).',
            date : '1st December 2010',
            field : 'Leadership',
            image : 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQiQJMK_AA2nXqamR1mBYMjppynqH560YTPyA&s'
        },
        {
            id : 5,
            title : 'Mohyal Gaurav',
            details : 'Dr Datta has been conferred with the “Mohyal Gaurav” award by the General Mohyal Sabha, the Apex Body of the Mohyal Community in January 2012.',
            date : 'January 2012',
            field : 'Leadership',
            image : 'https://mohyal.com/images/logo.png'
        },
        {
            id : 6,
            title : 'Silver Jubilee',
            details : 'Dr. Datta was awarded the Silver Jubilee (25 Years) award for development of NCMRWF by the Ministry of Earth Sciences.',
            date : '25th Anniversary',
            field : 'Development',
            image : 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRGmKQYSZAiZFEZVwbEPGtyJKCmoY-FxYrAHg&s'
        },
        {
            id : 7,
            title : 'Golden Jubilee',
            details : 'Dr. Datta was awarded the Golden Jubilee award of CSI (Computer Society of India).',
            date : '50th Anniversary',
            field : 'Fellowship',
            image : 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRGnicMMBfXdQJrZy9RvzmnhzvVw1bgLTs_qA&s'
        },
        {
            id : 8,
            title : 'The Lifetime Achievement Award',
            details : 'Dr. Datta was awarded “The Lifetime Achievement Award” in the field of IT by Computer Society of India (CSI).',
            date : '2nd December 2015',
            field : 'Research',
            image : 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRGnicMMBfXdQJrZy9RvzmnhzvVw1bgLTs_qA&s'
        },
        {
            id : 9,
            title : 'Bharat Jyoti Award',
            details : 'received the “Bharat Jyoti Award” by India International Friendship Society in there grand annual ceremony of the presentation of India\'s most coveted Institutional Presentation.',
            date : '9th June 2016',
            field : 'Research',
            image : 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQnjk0Lrjmz60OjdxenWt5Ek6ME9W2z6ZdIWw&s'
        },
        {
            id : 10,
            title : 'Bharat Ratna Mother Teresa Gold Medal',
            details : 'Global Economic Progress & Research Association honoured Dr. Datta with “Bharat Ratna Mother Teresa Gold Medal Award” on 26th December 2020 at Bangalore.',
            date : '26th December 2020',
            field : 'Research',
            image : 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcS-OKsS0D5mYXw-v1S_5f2eTT82oZXLxVGlUw&s'
        },
        {
            id : 11,
            title : 'Sir Gilbert Walker Gold Medal',
            details : 'Indian Meteorological Society honoured Dr. Datta with “Sir Gilbert Walker Gold Medal” on 18th November 2025 at Pune.',
            date : '18th November 2025',
            field : 'Leadership',
            image : 'https://imetsociety.org/wp-content/uploads/2023/01/ims-walker-medal.png',
            link: '/gilbert-walker-gold-medal'
        },
    ]
}


// Do not remove any fields.
// Leave it blank instead as shown below.

/*

export const achievementData = {
    bio : "",
    achievements : []
}

*/